import type { HTMLAttributes } from 'react';

import classNames from 'classnames';

import { Stack } from '@iconik-io/uad';

import styles from './page_layout.module.css';

export type PageLayoutProps = HTMLAttributes<HTMLDivElement>;

/**
 * Flex column that stacks a PageHeader above the page content with the
 * standard header gap; PageHeader itself has no bottom spacing.
 */
export function PageLayout({
  className,
  children,
  ...restProps
}: PageLayoutProps) {
  return (
    <Stack
      gap="xl"
      className={classNames(styles.page_layout, className)}
      {...restProps}
    >
      {children}
    </Stack>
  );
}
